@if (!flatLayout) {
  <div class="input-wrapper">
    <input
      #input
      cdkOverlayOrigin
      #filterColumnsTrigger="cdkOverlayOrigin"
      type="text"
      [attr.aria-label]="placeholder"
      [formControl]="searchPhrase"
      class="multi-select"
      [placeholder]="selectState"
      (focusin)="onFocusIn()"
      (focusout)="onFocusOut()"
    />
    @if (floatingTitle) {
      <span class="floating-title" [class.is-gradient]="isGrayGradient" (click)="input.focus()">
        {{ floatingTitle | translate }}
      </span>
    }

    @if (floatingRuTitle) {
      <span class="floating-title" [class.is-gradient]="isGrayGradient" (click)="input.focus()">
      {{ floatingRuTitle }}
    </span>
    }

    <svg [icon]="isOpen ? icons.ArrowDropUp : icons.ArrowDropDown" class="svg24 arrow_drop_down" (click)="input.focus()"></svg>

    @if (hasValue) {
      <button [matTooltip]="'OTHER.RESET' | translate" class="btn-empty clear-btn" (click)="clearAll($event)">
        <svg [icon]="icons.Close" class="svg20"></svg>
      </button>
    }
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="filterColumnsTrigger"
    [cdkConnectedOverlayOpen]="isOpen"
    (backdropClick)="onBackdropClick()"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="transparent-backdrop"
  >
    @if (!isCustomIconsDropdown) {
      <ng-container *ngTemplateOutlet="dropdown; context: { width: input.offsetWidth }"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="dropdownWithIcons"></ng-container>
    }
  </ng-template>
} @else {
  <ng-container *ngTemplateOutlet="flatLayoutTmpl"></ng-container>
}

<!--FLAT LAYOUT-->
<ng-template #flatLayoutTmpl>
  <div class="input-wrapper" [hidden]="hideInput">
    <input
      type="text"
      class="flat-search-input caption-2"
      placeholder="{{ ('DATA.TABLE_FILTER.SEARCH' | translate) + '...' }}"
      [attr.aria-label]="placeholder"
      [formControl]="searchPhrase"
    />
    <svg [icon]="icons.Search" class="svg24 search-icon" />
  </div>
  @if (!isCustomIconsDropdown) {
    <ng-container *ngTemplateOutlet="dropdown"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="dropdownWithIcons"></ng-container>
  }
</ng-template>

<ng-template #dropdownWithIcons>
  <form
    [formGroup]="selectForm"
    class="dropdown icons-dropdown-wrapper"
    *ngLet="filteredOptions$ | async as filteredOptions"
    [style.width.px]="dropdownWidth"
    [class.border-top]="hideInput"
  >
    <div class="icons-dropdown">
      <ng-container formArrayName="options" *ngFor="let control of optionsFormArray.controls; let i = index">
        <label class="icons-dropdown-item" *ngIf="filteredOptions?.includes(options[i]?.title)" (change)="checkOption()">
          <input type="checkbox" class="checkbox" [formControlName]="i" />
          <div class="svg32 icons-item-icon category-icon" *ngIf="options[i].imageCode" [innerHTML]="options[i].imageCode ?? '' | safeHTML"></div>
          <span class="body-2 icons-item-title">{{ options[i].title }}</span>
          <span class="caption-4 icons-item-subtext">{{ options[i].subtext }}</span>
        </label>
      </ng-container>
    </div>
  </form>
</ng-template>

<!--DROPDOWNS-->
<ng-template #dropdown let-width="width">
  <form
    [formGroup]="selectForm"
    class="dropdown"
    *ngLet="filteredOptions$ | async as filteredOptions"
    [style.width.px]="dropdownWidth ?? width"
    [class.border-top]="hideInput"
  >
    @if (showChooseAllBtn) {
      <mat-checkbox
        class="option-checkbox choose-all-checkbox"
        [checked]="chooseAll"
        [indeterminate]="isIndeterminate"
        (change)="setAllChosen($event.checked)"
      >
        {{ chooseAllText | translate }}
      </mat-checkbox>
    }
    @if (filteredOptions.length < 200) {
      <div class="ng-for-option-container" [style.height.px]="options.length > 4 ? maxDropdownHeight : options.length * optionHeight">
        @for (control of optionsFormArray.controls; track $index) {
          <ng-container formArrayName="options">
            @if (filteredOptions?.includes(options[$index]?.title)) {
              <mat-checkbox
                class="option-checkbox"
                [formControlName]="$index"
                (change)="checkOption()"
              >
            <span class="checkbox-label-wrapper">
              {{ options[$index].title }}
              <small class="caption-4 subtext">{{ options[$index].subtext }}</small>
            </span>
              </mat-checkbox>
            }
          </ng-container>
        }
      </div>
    } @else {
      @if (isSearchFilter) {
        <app-multiple-select
          [options]="filteredMultipleOptions"
          [selectedOptionIndexes]="selectedMultipleOptionIndexes"
          (changeSelected)="changeMultipleSelection($event)"
        ></app-multiple-select>
      } @else {
        <cdk-virtual-scroll-viewport
          [itemSize]="optionHeight"
          [style.height.px]="options.length > 4 ? maxDropdownHeight : options.length * optionHeight"
        >
          <ng-container formArrayName="options" *cdkVirtualFor="let control of optionsFormArray.controls; let i = index">
            @if (filteredOptions?.includes(options[i]?.title)) {
              <mat-checkbox class="option-checkbox" [formControlName]="i" (change)="checkOption()">
            <span class="checkbox-label-wrapper">
              {{ options[i].title }}
              <small class="caption-4 subtext">{{ options[i].subtext }}</small>
            </span>
              </mat-checkbox>
            }
          </ng-container>
        </cdk-virtual-scroll-viewport>
      }
    }
  </form>
</ng-template>
